<process-monitoring-goal-setting-details-template
  class="flex flex-1 h-full"
  [loading]="loading"
  [loadingUsers]="loadingUsers"
  [loadingUsersCount]="loadingFilters"
  [processName]="processName"
  [countersCardData]="countersCardData"
  [usersData]="usersData"
  [usersDataCount]="usersDataCount"
  [totalPages]="totalPages"
  [searchedText]="searchedText"
  [page]="page"
  [pageSize]="pageSize"
  [sortOptions]="sortOptions"
  [selectedSortOption]="selectedSortOption"
  [drawerVisible]="drawerVisible"
  [activeFiltersCount]="activeFiltersCount"
  [appliedChips]="appliedChips"
  [cardStatusOptions]="cardStatusOptions"
  [proposalStatusOptions]="proposalStatusOptions"
  [updatesOptions]="updatesOptions"
  [scorecardTypeOptions]="scorecardTypeOptions"
  [managerOptions]="managerOptions"
  [departmentOptions]="departmentOptions"
  [selectedCardStatuses]="selectedCardStatuses"
  [selectedProposalStatuses]="selectedProposalStatuses"
  [selectedUpdates]="selectedUpdates"
  [selectedScorecardTypes]="selectedScorecardTypes"
  [selectedManagers]="selectedManagers"
  [selectedDepartments]="selectedDepartments"
  [filtersValues]="filtersValues"
  (backClick)="goBack()"
  (searchChange)="onSearchChange($event)"
  (searchUsers)="onSearchUsers()"
  (sortChange)="onSortChange($event)"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (advancedFiltersClicked)="onAdvancedFiltersClick()"
  (solicitDefinitionsClicked)="onSolicitDefinitionsClicked()"
  (solicitProposalsClicked)="onSolicitProposalsClicked()"
  (solicitUpdatesClicked)="onSolicitUpdatesClicked()"
  (exportXlsClicked)="onExportXlsClicked($event)"
  (removeFilterChip)="onRemoveFilterChip($event)"
  (cardStatusesChange)="onCardStatusesChange($event)"
  (proposalStatusesChange)="onProposalStatusesChange($event)"
  (updatesChange)="onUpdatesChange($event)"
  (scorecardTypesChange)="onScorecardTypesChange($event)"
  (managersChange)="onManagersChange($event)"
  (departmentsChange)="onDepartmentsChange($event)"
  (applyFilters)="applyFilters()"
  (resetFilters)="resetFilters()"
  (closeDrawer)="closeDrawer()"
  (impersonateUser)="onImpersonateUser($event)"
  (impersonateManager)="onImpersonateManager($event)"
  (downloadPdf)="onDownloadPdf($event)"
  (solicitManager)="onSolicitManagerClicked($event)"
  (solicitUser)="onSolicitUserClicked($event)"
  (solicitManagerUpdate)="onSolicitManagerUpdateClicked($event)"
/>

<!-- Modale unica di conferma per i 4 tipi di sollecito (M3/M4 singoli e massivi).
     Titolo e descrizione provengono da getter sul componente (solicitModalTitleKey
     e solicitModalDescription) per ridurre la complessità delle ternarie a UI. -->
<ape-modal
  *ngIf="solicitConfirm.visible"
  [visible]="solicitConfirm.visible"
  [title]="solicitModalTitle"
  [description]="solicitModalDescription"
  [primaryActionLabel]="TRANSLATION_KEYS.admin.goalSettingMonitoring.solicit.CONFIRM_BUTTON | translate"
  [secondaryActionLabel]="TRANSLATION_KEYS.admin.goalSettingMonitoring.solicit.CANCEL_BUTTON | translate"
  [showSecondaryButton]="true"
  [primaryActionLoading]="solicitConfirm.sending"
  [primaryActionDisabled]="solicitConfirm.sending"
  (onClose)="cancelSolicit()"
  (onCancel)="cancelSolicit()"
  (onConfirm)="confirmSolicit()"
/>
